<span [class.text]="true" [class.memo]="isMemo()">{{ value }}</span>
